import { observer } from 'mobx-react-lite';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { messageStore } from '../../stores/MessageStore';

function ConfirmDialog() {
	const { message, openConfirmation, onConfirm, confirmationTitle, showConfirmationCancel } = messageStore;

	const closeDialog = () => {
		messageStore.closeConfirm();
	};

	const handleConfirm = () => {
		messageStore.closeConfirm();
		onConfirm && onConfirm();
	}

	return (
		<Dialog
			open={openConfirmation}
			onClose={closeDialog}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">
				{confirmationTitle}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description" className='text-pre-wrap'>
					{message}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				{showConfirmationCancel && <Button onClick={closeDialog}>Cancel</Button>}
				<Button onClick={handleConfirm} autoFocus>Ok</Button>
			</DialogActions>
		</Dialog>
	);
}

export default observer(ConfirmDialog);
